/**
 * The invisible marker over the active misspelled word on the canvas, or `null` when none is drawn.
 *
 * The frame that holds the word (or its overflow peek, for a word in hidden text) marks it with
 * `data-spell-anchor="start-end"`, the word's `[start, end)` in the frame's whole text
 * (`SpellWordAnchor`). That is the one place the word's position on screen is known, so the Spell
 * Check popover reads it from here instead of measuring text itself. The marker is there whether or
 * not Show underlines is on.
 */
export function findSpellWordElement(
  shapeId: string,
  start: number,
  end: number
): HTMLElement | null {
  const frame = document.querySelector<HTMLElement>(
    `[data-shape-text-overlay][data-shape-id="${CSS.escape(shapeId)}"]`
  )

  return frame?.querySelector<HTMLElement>(`[data-spell-anchor="${start}-${end}"]`) ?? null
}
